import styled from 'styled-components'
import getBreakpoint from '@client/utils/breakpoints'

export const PlanSelectorWrapper = styled.section`
  display: flex;
  flex-wrap: wrap;

  @media (min-width: ${getBreakpoint('xl')}px) {
    padding: 10px;
    box-shadow: 0px 2px 6px rgba(152, 152, 167, 0.25);
    border-radius: 100px;
    background: #ffffff;
  }
`

export const PlanSelectorItem = styled.button`
  ${({ pastSelected, selected, disabled, theme }) => `
    display: flex;
    align-items: center;
    border: 1px solid #A9A9B8;
    border-radius: 100px;
    margin-right: 16px;
    margin-bottom: 16px;
    padding: 0;
    font-size: 16px;
    cursor: ${disabled ? 'not-allowed' : 'pointer'};
    background-color: transparent;
    color: #6b6b78;

    span {
      padding: 4px 16px;

      @media (min-width: ${getBreakpoint('xl')}px) {
        padding: 15px 21px;
      }
    }

    &:focus {
      outline: 0;
    }

    &:first-of-type {
      border-top-left-radius: 100px;
      border-bottom-left-radius: 100px;
    }

    @media (min-width: ${getBreakpoint('xl')}px) {
      border-radius: 0;
      border: none;
      margin-right: 0;
      margin-bottom: 0;
    }

    ${
      selected
        ? `
        background-color: #f0f0f6;
        
        @media (min-width: ${getBreakpoint('xl')}px) {
          border-top-right-radius: 100px;
          border-bottom-right-radius: 100px;
        }

        span {
          display: flex;
          align-items: center;
          background-color: ${theme.span.backgroundColor ||
            'var(--sao-paulo-60);'}
          font-weight: 600;
          color: #ffffff;
          border-radius: 100px; 
          position: relative;
        }
      `
        : ''
    }

    ${
      pastSelected
        ? `
        background-color: #f0f0f6;
        color: #9898A7;
    `
        : ''
    }
 `}
`
